import { Box, Button, Card, CardContent, Grid, Typography } from "@mui/material";
import { useIsMobileView } from "../../utils/responsive";
import { useAppSelector } from "../../store/hooks/useAppSelector";
import { RootState } from "../../store/types/rootState";
import { useGetAccountsQuery } from "../../store/api";
import { AccountTableList } from "./account-list/table";
import { useSelector } from "react-redux";

export const AccountsList = () => {

  const accountInformation = useAppSelector(({ account }: RootState) => account);
  const profile = useSelector(({ user }: RootState) => user.profile);

  const { data: accountsFounded = [], error: errorGetRaffles } = useGetAccountsQuery(undefined, {
    skip: accountInformation.id !== 'vip-rifas'
  });

  // Filtrar por fecha si el perfil es operator (solo cuentas creadas después del 3-11-2025)
  const filterDate = new Date('2025-11-03T00:00:00Z'); // 3 de noviembre de 2025
  
  const filteredAccounts = profile === 'operator' 
    ? accountsFounded.filter(account => {
        // Si createdAt existe, comparar; si no, incluir la cuenta (por compatibilidad)
        if ((account as any).createdAt) {
          const accountDate = new Date((account as any).createdAt);
          return accountDate > filterDate;
        }
        return true; // Si no tiene createdAt, incluirla para no romper nada
      })
    : accountsFounded;

  const totalAccounts = filteredAccounts.length;

  const ownerAccounts = filteredAccounts.filter(account => account.owner).length;

  return (
    <Grid container spacing={2} sx={{ background: '#000', p: 2 }}>
      <Grid item xs={12}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={2}>
            <Typography variant="h6">Total Clientes</Typography>
            <Typography variant="h4" fontWeight="bold">{totalAccounts}</Typography>
          </Grid>

        
          <Grid item xs={12} sm={1}>
            <Typography variant="h6">Dueños</Typography>
            <Typography variant="h4" fontWeight="bold">{ownerAccounts}</Typography>
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={12} sm={12} xl={12} md={12}>
          <AccountTableList accounts={filteredAccounts} />
      </Grid>
    </Grid>
  );
};
